<script lang="ts">
  let {
    size = 16,
    color = "currentColor",
    class: cls = "",
  }: {
    size?: number;
    color?: string;
    class?: string;
  } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  class="animate-spin {cls}"
  aria-hidden="true"
>
  <circle
    cx="12"
    cy="12"
    r="10"
    stroke={color}
    stroke-width="3"
    stroke-linecap="round"
    stroke-dasharray="60 200"
  />
</svg>
